import {Command, CommandMeta, DeriveJSONSchema, SimpleSchema} from "mobx-graphlink";
import {RecordingSession} from "../DB/recordingSessions/@RecordingSession.js";

const MTClass = RecordingSession;
type MT = typeof MTClass.prototype;

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		entry: DeriveJSONSchema(MTClass, {}),
	}),
	responseSchema: ()=>SimpleSchema({id: {$ref: "UUID"}}),
})
export class AddRecordingSession extends Command<{entry: MT}, {id: string}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		$id: {$ref: "UUID"},
		$updates: DeriveJSONSchema(MTClass, {excludeKeys: ["id", "creator", "createdAt"], makeOptional_all: true}),
	}),
})
export class UpdateRecordingSession extends Command<{id: string, updates: Partial<MT>}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		id: {$ref: "UUID"},
	}),
})
export class DeleteRecordingSession extends Command<{id: string}> {}